/**
 * Conveyor Package Event resource
 *
 * @name ConveyorPackageEvent
 * @class
 * @augments TmrResource
 */
export const factory = [
  'ConveyorPackageEvent',
  /*@ngInject*/ (TmrResource, Conveyor) => {
    let referencedProperties = [
      // conveyorPackageEvent.conveyor property will be instantiated as a Conveyor resource
      { property: 'conveyor', resource: Conveyor },
    ]
    return TmrResource('ConveyorPackageEvent', {}, referencedProperties)
  },
]
